package com.partejar.app.core.format

import kotlinx.datetime.LocalTime

/** A local clock time, with no timezone conversion or implicit default. */
internal fun parseClockTime(value: String): LocalTime? {
    if (!Regex("[0-9]{2}:[0-9]{2}").matches(value)) return null
    return runCatching { LocalTime.parse(value) }.getOrNull()
}

internal fun formatClockTime(time: LocalTime): String =
    "${time.hour.toString().padStart(2, '0')}:${time.minute.toString().padStart(2, '0')}"

/** Complete an hour-only draft on blur; never turn invalid input into a valid time. */
internal fun normalizeClockTimeOnBlur(value: String): String {
    if (!Regex("[0-9]{1,2}").matches(value)) return value
    val candidate = value.padStart(2, '0') + ":00"
    return candidate.takeIf { parseClockTime(it) != null } ?: value
}
